module.exports = __webpack_public_path__ + "static/media/06-video.a8113b13.png";